import { lazy, Suspense } from 'react';
import type { Tab } from '../../lib/workspace';
import { BinItemList } from './BinItemList';
import { CorridorItemList } from './CorridorItemList';

// Lazy-loaded main panel components
const LayoutOverview = lazy(() => import('../../pages/LayoutPage'));
const CorridorView = lazy(() => import('../../pages/CorridorPage'));
const MissingPage = lazy(() => import('../../pages/MissingPage'));
const AssignmentsPage = lazy(() => import('../../pages/AssignmentsPage'));
const SpecialBinsPage = lazy(() => import('../../pages/SpecialBinsPage'));
const ArchivePage = lazy(() => import('../../pages/ArchivePage'));

function Loading() {
  return <div className="flex-1 flex items-center justify-center text-tertiary text-[13px]">Yukleniyor...</div>;
}

// Render main panel tab content
export function MainTabContent({ tab }: { tab: Tab }) {
  return (
    <Suspense fallback={<Loading />}>
      {(() => {
        switch (tab.type) {
          case 'layout-overview': return <LayoutOverview />;
          case 'corridor': return <CorridorView aisle={tab.params.aisle as number} />;
          case 'missing': return <MissingPage />;
          case 'assignments': return <AssignmentsPage />;
          case 'special-bins': return <SpecialBinsPage />;
          case 'archive': return <ArchivePage />;
          default: return <div className="p-4 text-tertiary">Bilinmeyen tab tipi: {tab.type}</div>;
        }
      })()}
    </Suspense>
  );
}

// Render bottom panel tab content
export function BottomTabContent({ tab }: { tab: Tab }) {
  switch (tab.type) {
    case 'bin': return <BinItemList binCode={tab.params.binCode as string} />;
    case 'corridor-items': return <CorridorItemList aisle={tab.params.aisle as number} zone={tab.params.zone as string | null} />;
    default: return <div className="p-4 text-tertiary">Bilinmeyen tab tipi: {tab.type}</div>;
  }
}
